import { GetDefaultHeaders } from './Helpers';
import SingletonConfig from 'utils/global';
import { HOST_URL } from 'config';
export default class AjaxUtil {
  static isRedirecting = false;
  //old
  static genericSendPost(url, body, headersObject = GetDefaultHeaders()) {
    return new Promise((resolve, reject) => {
      fetch(url, {
        credentials: process.env.REACT_APP_CREDENTIALS_MODE,
        headers: headersObject,
        method: 'post',
        body: body
      })
        .then(response => {
          if (response.status == 200) {
            response.json().then(x => {
              resolve(x);
            });
          } else if (response.status == 401 || response.status == 403) {
            reject('You do not have permission to execute this action');
          } else if (response.status == 300) {
            const self = this;
            setTimeout(() => {
              if (self.isRedirecting) {
                return;
              }
              self.isRedirecting = true;
              const redirectUrl = response.headers.get('Location');
              if (!redirectUrl) {
                reject('An error occurred during the dashboard user redirect');
              }
              const fullUrl = new URL(redirectUrl, window.location.origin);
              fullUrl.searchParams.set('referrer', window.location.href);
              window.location.href = fullUrl.toString();
            }, 100);
            resolve({ redirect: true });
          } else {
            reject(response.statusText || 'An error occurred during the action');
          }
        })
        .catch(err => {
          console.warn(`genericSendPost: url: ${url}, got error -> ${err}`);
          reject(err);
        });
    });
  }
  static postDownloadFile(url, body, headersObject = GetDefaultHeaders()) {
    return new Promise((resolve, reject) => {
      fetch(url, {
        credentials: process.env.REACT_APP_CREDENTIALS_MODE,
        headers: headersObject,
        method: 'post',
        body: body
      })
        .then(response => {
          if (response.ok) {
            const disposition = response.headers.get('Content-Disposition').split(';');

            let fileName = disposition.find(v => v.includes('filename='));
            if (!!fileName) {
              fileName = fileName.replace('filename=', '').trim();
            }

            response.blob().then(blob => {
              let url = window.URL.createObjectURL(blob);
              if (!!fileName) {
                let a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
              } else {
                window.location.assign(url);
              }
              resolve(true);
            });
          } else if (response.status == 401 || response.status == 403) {
            reject('You do not have permission to execute this action');
          } else {
            reject(response.statusText || 'An error occurred during the action');
          }
        })
        .catch(err => {
          console.warn(`postDownloadFile: url: ${url}, got error -> ${err}`);
          reject(err);
        });
    });
  }
  static sendGet(url, headersObject = GetDefaultHeaders()) {
    return new Promise((resolve, reject) => {
      fetch(url, {
        credentials: process.env.REACT_APP_CREDENTIALS_MODE,
        headers: headersObject,
        method: 'GET'
      })
        .then(response => {
          if (response.status == 200) {
            resolve(response.json());
          } else if (response.status == 401 || response.status == 403) {
            reject('You do not have permission to execute this action');
          } else if (response.status == 300) {
            const self = this;
            setTimeout(() => {
              if (self.isRedirecting) {
                return;
              }
              self.isRedirecting = true;
              const redirectUrl = response.headers.get('Location');
              if (!redirectUrl) {
                reject('An error occurred during the dashboard user redirect');
              }
              const fullUrl = new URL(redirectUrl, window.location.origin);
              fullUrl.searchParams.set('referrer', window.location.href);
              window.location.href = fullUrl.toString();
            }, 200);
            resolve({ redirect: true });
          } else {
            reject(response.statusText || 'An error occurred during the action');
          }
        })
        .then(json => resolve(json))
        .catch(err => {
          console.warn(err);
          reject(err);
        });
    });
  }
  static checkResponseErrorCode(response) {
    if (response.status == 301) {
      window.location.replace('/Login');
    }
    return response;
  }

  static getUrl(path, baseControllerPath = null) {
    return `${HOST_URL}${baseControllerPath ?? SingletonConfig.baseControllerPath}${path}`;
  }
}
